// Chinese (Traditional)
export const ZH_HANT = {
  banner: {
    error: "報價尚未更新，請稍候",
    copicate: "試試新的投資組合模式！",
    antimonitor: "點擊此處前往購買和交易加密貨幣的最佳場所！",
  },
  footer: {
    donating: "如果您喜歡 CoinTrackr，請考慮進行捐贈！",
    right_reserve:
      "©版權所有 " +
      new Date().getFullYear() +
      " CoinTrackr.com。保留部分權利。",
    version: "版本",
    changelog: "變更日誌",
    powered_by: "技術支援",
  },
  top: {
    about: {
      info: "資訊",
      FAQ: "常見問答",
      contact: "聯絡方式",
      partners: "合作夥伴",
      terms: "條款",
      privacy: "隱私",
    },
  },
  content: {
    valuation: {
      current_valuation: "當前估值",
      approx: "預計.",
    },
    profit_losses: "損益",

    updating_assets: "更新資產",
    updated_now: "上次更新：剛剛",
    last_update: `上次更新：{time} 秒前`,
    last_update_minutes: `上次更新：{minutes} 分 {seconds} 秒前`,
  },
  assets: {
    your_assets: "资产",
    add_asset: "添加資產",
    sort: "排序方式",
    sort_name: {
      name: "名稱",
      exchId: "兌換",
      price: "價格",
      value: "估值",
      holdings: "持倉",
      percChangeHour: "小時",
      percChangeDay: "天",
      percChangeWeek: "周",
    },
  },
  charts: {
    color_help: "點擊圓圈以更改顏色",
  },
  contact_page: {
    contact: "聯絡方式",
    help_feedback: "幫助和反饋",
    telegram: "Telegram",
    twitter: "Twitter",
    medium: "Medium",
    busines: "業務諮詢",
    email: "郵件",
  },
  partner_page: {
    partners: "合作夥伴",
    bitsify: "Bitsify 將提供完整的 ICO 與眾籌報告",
    bitcoin: "Bitcoin for Beginners 是適合初學者的加密貨幣學習社區。",
    interest: "想要成為我們的合作夥伴？",
    contact_us: "聯絡我們！",
  },
  user_menu: {
    not_logged: "未登入",
    icognito: "隱身",
    settings: "設定",
    sign_in: "登入",
    sign_out: "登出",
    valuation: "在標籤頁中展示估值",
    incognito: "隱身模式",
    night_mode: "夜間模式",
    share_link: "創建分享連結",
  },
  FAQ: {
    expand: "展開全部",
    collapse: "收起全部",
    0: {
      title: "CoinTrackr 是什麼？",
      text:
        "CoinTrackr 一項免費、簡單而又便於使用的服務，可助力追跡加密貨幣投資。",
    },
    1: {
      title: "我該如何在 CoinTrackr 上創建投資組合？",
      text:
        "這個問題的答案非常簡單！只需移除範本投資組合中的資產，並以您自己的資產對其進行替換即可。您可通過點擊某個資產來將其移除或對其進行編輯。",
    },
    2: {
      title: "CoinTrackr 會從哪裡獲取數位貨幣價格？這些價格是否準確？",
      text:
        '所有價格數據均取自 <a href="https://coinmarketcap.com">coinmarketcap.com</a>，以 CoinMarketCap 支持的所有交易所價格的平均值表示。鑒於 CoinTrackr 使用的是價格平均值，故其可能會與您所關注的交易所確切價格略有不同。',
    },
    3: {
      title: "如何從Cointrackr添加API金鑰和交易？",
      text:
        "只需按照我們的專用頁面<a href=“/exchange/how-it-works”>這裡</a>中的說明操作即可。",
    },
    4: {
      title: "您是否計畫添加更多的交易？",
      text:
        "是的，我們計畫新增盡可能多的交易，他們提供為客戶生成API金鑰的可能性。",
    },
    5: {
      title: "估值是什麼？如何確定其金額？",
      text:
        "估值是您添加至 CoinTrackr 中的資產的總價值；即您當前加密貨幣投資組合的總價值。",
    },
    6: {
      title: "為什麼我找不到某些數位貨幣？",
      text:
        "如果您確定數位貨幣名稱拼寫正確，且又無法找到的話，那麼應該是 CoinMarketCap 尚未對該數位貨幣做出支持。我們正在添加多個價格數據來源，您所感興趣的數位貨幣將在未來得到支持。",
    },
    7: {
      title: "我的投資組合數據與登入資訊會以何種方式存儲？",
      text:
        "如果您未登錄，那麼所有數據都將存儲於瀏覽器緩存中。您可關閉窗口並稍後繼續，無需再次添加資產。" +
        "\n" +
        "如果您已在 CoinTrackr 上（使用社交媒體/郵件與密碼）進行了注册，那麼數據會被存儲於資料庫中。我們採用這一方式 的目的是便於您在不同設備（如案頭端和移動端）之間進行實时同步，這樣即使您清除了瀏覽器緩存，數據也會得到存儲。",
    },
    8: {
      title: "創建 CoinTrackr 帳戶的過程是否安全？",
      text:
        '是。我們僅在實現 CoinTrackr 關鍵功能時使用您的數據。同時我們也不會將您的數據傳遞給協力廠商。請查看我們的<a href="/privacy">隱私政策<a/>瞭解詳細資訊。',
    },
    9: {
      title: "CoinTrackr 是否有興趣與我的加密貨幣相關服務/社區開展合作？",
      text: '當然。請<a href="/contact">聯系<a/>我們以探討更多可能性！',
    },
  },
  add_page: {
    search: "按名稱或標誌進行檢索",
    add_asset: "添加資產",
    any_asset: {
      1: "支持所有已收錄於",
      2: "的資產（數位貨幣與代幣）",
    },
    next: "下一步",
    no_result: "未找到結果：",
  },
  register_page: {
    register: "注册",
    agree: "注册即表示您同意我們的",
    terms: "條件與條款",
    and: "以及",
    privacy: "隱私政策",
    p_reg:
      "只有當您想<b>保存投資組合</b>以在<b>其他設備</b>上使用，或者在<b>清除瀏覽器緩存</b>的情况下保護數據免遭遺失時才需要注册。",
    errors: {
      email_required: "郵件為必填項。",
      email_valid: "需提供有效的電子郵件",
      password_required: "密碼為必填項。",
      password_length: "密碼必須至少包含 {length} 個字元。",
      password_match: "密碼必須匹配。",
    },
    placeholder: {
      email: "輸入您的郵件",
      password: "輸入您的密碼",
      password_repeat: "重複您的密碼",
    },
    create_account: "創建帳戶",
  },
  login_page: {
    placeholder: {
      email: "輸入您的郵件",
      password: "輸入您的密碼",
    },
    errors: {
      email_not_found: "沒有與此識別字對應的用戶記錄。用戶可能已被删除。",
      not_email: "郵件地址格式不正確。",
    },
    forget_password_text: "如果您忘記密碼，請單擊此處重設密碼",
    forget_password_text_back: "返回登錄",
    reset_password: "重設密碼",
    reset_password_p:
      "在下面輸入您的電子郵件地址，我們將向您發送電子郵件以重置密碼。",
    reset_password_success:
      "CoinTrackr 的密碼重置消息已發送。 檢查您的收件箱，然後回來。",
    // forget_password_text: '如果您忘記了密碼，請發送電郵至 <a href="mailto:info@cointrackr.com">info@cointrackr.com</a> 進行重置',
  },
  share_page: {
    heading: "創建分享連結",
    just_second: "請稍候…",
    porfolio_not_found: "未找到投資組合",

    p_1:
      "<strong>CoinTrackr</strong> 是一款免費的<strong>加密貨幣投資組合管理工具</strong>，可幫助您追跡損益情况，並<strong>與他人分享您的投資組合</strong>。",
    create_own: "免費創建",

    p_2:
      "<strong>有人與您分享了其投資組合！</strong> <br> CoinTrackr 是一項免費的加密貨幣投資組合服務，支持超過4000種數位貨幣與代幣。",
    porfolio: "投資組合",
    profit_losed: "損益",

    created: "已創建",
    dialog: {
      p_1:
        "分享您的投資組合將創建一個<strong>公開連結</strong>，展示您的<strong>匿名投資組合</strong>。其中將<strong>僅包含百分比數據</strong>，不會展示估值或價格。此連結將無法用於追跡您的身份資訊，可完全安全地與任何人共亯。",
      add_message: "<strong>添加一則消息</strong> <em>（可選）</em>",
    },
    create_shareble: "創建分享連結",
    create_own_free: "創建您自己的投資組合",
    messages: {
      already: "您的投資組合連結已可分享！🙌",
      copied: "已複製您的連結！🎉",
      not_copied: "無法複製您的連結。請手動複製。😢",
      failed: "連結創建失敗，請重試。😢",
    },
  },
  global: {
    add_first: "添加您的首個資產",

    not_now: "不是現在",
    not_right_now: "現在不要",
    close: "關閉",
    go_back: "返回",
    share: "%份額",

    price: "價格",

    day: "天",
    hour: "小時",
    week: "周",
    valuation: "估值",
    holdings: "持倉",
    name: "名稱",
    actions: "操作",
    edit: "編輯",
    notes: "筆記",

    last_7_days: "最近 7 天",
    last_24_hour: "最近 24 小時",
    last_hour: "最近 1 小時",

    login: "登入",
  },
  sign_in_dialog: {
    button: {
      email: "使用郵件登入",
      facebook: "使用 Facebook 登入",
      google: "使用 Google 登入",
      twitter: "使用 Twitter 登入",
    },
    p:
      "只有當您想<b>保存投資組合</b>以在<b>其他設備</b>上使用，或者在<b>清除瀏覽器緩存</b>的情况下保護數據免遭遺失時才需要登入帳戶。",
  },
  notifications: {
    sign_in: "您已登入。",
    sign_out: "您已註銷。",
    HODL: "為什麼不拿著呢？😭",
    dont_worry: "別擔心，放輕鬆…然後双手攥緊🎶🚀",
  },
  edit_asset_page: {
    add: "添加或編輯",
    how_much: "您持有多少{assetName} {assetSymbol}？",
    save: "保存",
    delete: "删除",
    notes_label: "{assetName} {assetSymbol}的注釋",
    notes_placeholder:
      "在此處添加您的注釋，如購買價格、交易、錢包地址或與資產相關的任何其他注釋",
  },
  exchange: {
    exchange: "兌換",
    trade: "貿易",

    your_api_keys: "您的API金鑰",
    how_it_works: "它是如何工作的？",

    home_valuation_per_exchange: "每交易所估值",
    home_show_valuation_per_exchange: "顯示每筆交易的估值",
    home_tooltip_info: "請參閱有關Exchange API金鑰的資訊",

    api_key: "API金鑰",
    secret: "秘密",
    add: "添加",
    update: "更新",
    cancel: "取消",
    add_your_exchange_api_key: "添加你的{exchange}API金鑰",
    add_exchange_api_key: "添加{exchange}API金鑰",
    update_exchange_api_key: "更新{exchange}API金鑰",
    api_keys_page_note:
      "重要提示：在存款/取款和任何已填寫的訂單之後，Binance會有15分鐘的重繪延遲。<br/>報價是實时的",

    pick_a_ticker_to_trade: "選擇要交易的股票：",
    select_ticker: "選擇股票代碼",

    loading: "加載..",
    Buy: "購買",
    Sell: "出售",
    LIMIT: "限制",
    MARKET: "市場",

    amount: "餘額",
    you_have: "持有",
    total: "總額",

    place_buy_order: "下購買訂單",
    place_sell_order: "下銷售訂單",

    order_placed: "訂單已下！",

    you_dont_have_assets: "你沒有可以交易的資產",

    orders_history: "訂單歷史",
    orders_open: "未結訂單",
    orders_history_empty: "{ticker}的訂單歷史記錄為空",
    orders_open_empty: "現時{ticker}沒有公開訂單",
    symbol: "符號",
    side: "一邊",
    type: "類型",
    price: "價格",
    status: "職位",
    stopPrice: "止損價",
    executedQty: "執行數量",
    time: "時間",
    action: "行動",
  },
  exchange_info_page: {
    blocks: [
      {
        heading: "CoinTrackr主要更新",
        p: [
          "多年來，CoinTrackr為所有有價值的用戶免費提供了數十億份報價，現在，CoinTrackr自豪地宣佈了一項重大突破，從今天開始，您可以在CoinTrackr上跟踪您在各種交易所持有的真正加密資產！還有一件事…。",
          "不僅僅是跟踪！Cointrackr也很高興宣佈這些資產的交易功能，這意味著您將能够在Cointrackr內跟踪和交易它們！！",
        ],
      },
      {
        heading: "它是如何工作的？",
        p: [
          "每個大型交易都允許用戶使用API連接到另一個平臺。例如，如下所示，Binance在此處提供此選項：",
          "1）注册CoinTrackr，然後進入選單“您的API金鑰” ",
          "2）從Binance帳戶複製粘貼API金鑰和金鑰。<br /> 下麵是一幅描述步驟的快速影像：",
          "重要提示：僅啟動“啟用讀取”和“啟用現貨和保證金交易” <br /> 和關於IP限制設定CoinTrackr IP地址：<strong>{exchangeApiIP}</strong>",
          "完成後，請等待15分鐘以進行同步，轉到主頁，您將看到由Binance徽標表示的Binance中的資產。",
          "還有一個重要的區別是，在使用經典的CoinTrackr資產之前，您使用了編輯按鈕，顯然這個按鈕變成了“交易”，因為從今天起，您可以在CoinTrackr上管理和交易您的交易所投資組合。",
          "現在讓我們看看您的CoinTrack儀錶板是什麼樣子：",
          "現在，在第一頁，您將與Binance和經典CoinTrackr中的資產進行區分。",
          "正如您所看到的，您有一個新的列，用於區分每個交易所的資產。<br /> >Cointrackr徽標是為您一直跟踪的實際經典資產設定的。<br /> >Binance在這裡，是您的真實資產在您的Binance live帳戶跟踪。",
        ],
      },
      {
        heading: "交易平臺",
        p: [
          "（在接受我們的條款和條件後）",
          "現在讓我們看看CoinTrackr交易平臺，您可以隨時通過按一下您的每項交易資產上的“交易”來訪問該平臺：",
          "如您在此處所見，按一下“交易”後，您可以選擇：<br /> “買入/賣出”，有兩個選項“限價指令”和“市場”您的基礎資產",
          '注意：為了啟用此選項，當您使用“啟用現貨和保證金交易”選擇創建Binance API時，應選擇“授權交易”，<a href="#step-2-binance-setup">請按一下此處再次查看Binance設定。</a>',
          "如果不想使用此功能，您仍然可以像以前一樣跟踪資產。",
          "今天，我們提供跟踪的第一個交易是Binance，接下來是更多的交易：）",
          '<a href="mailto:info@cointrackr.com">info@cointrackr.com</a>如果您有任何問題或發現bug，謝謝。',
        ],
      },
    ],
  },
  profitloss: {
    pl: "利潤率",
    profitloss: "利潤/損失",
    realized_profitloss: "實現利潤率",
    total_balance: "總餘額",
    mode: "模式",
    portfolio: "資料夾",
    current: "當前",
    history: "歷史",
    investment: "投資",
    average: "平均",
    transaction: "交易",
    transactions: "交易",
    hide: "隱藏",
    show: "顯示",
    asset_notes_label: "資產注釋標籤",
    asset_notes_placeholder: "資產注釋預留位置",
    reset_portfolio: "重置投資組合",
    reset_portfolio_text: "重置資料夾文字",
    list_empty: "清單為空",

    quantity: "量",
    value: "價值",
    date: "日期",
    buy_price: "買價",
    buy_value: "購買價值",
    buy_date: "購買日期",
    showInValuation_help: "將損益計入當期估值",
    transaction_notes_placeholder: "添加與此交易相關的注釋",
    sell_close: "成交",
    total_valuation: "總估值",
    delete_transaction_text: "删除交易記錄",

    sell_price: "賣出價",
    sell_value: "賣價",
    sell_date: "出售日期",
    history_transaction_hint: "歷史\交易\提示",

    original_buy_transaction: "原始購買交易",
    left_unsold: "未售出",
    originally: "初始",
    dependent_transactions: "您已關閉此資產的事務總計",
  },
};
